import React from 'react';
import './AutoPriceInfo.css';

const AUTO_PRICE_POINTS = [
    'Moves your price each time we get new PriceCharting estimates.',
    'Drops are capped at 1% a day, so a bad estimate can\'t misprice your card.',
    'PSA 6 and below follow PSA 9 market moves.',
];

// preventDefault keeps a click on the icon from toggling the checkbox when it sits inside a <label>.
const AutoPriceInfo = () => (
    <span
        className="auto-price-info"
        tabIndex={0}
        aria-label={`Recommended. ${AUTO_PRICE_POINTS.join(' ')}`}
        onClick={(e) => e.preventDefault()}
    >
        i
        <span className="auto-price-info-bubble" role="tooltip">
            <span className="auto-price-info-badge">Recommended</span>
            <span className="auto-price-info-points">
                {AUTO_PRICE_POINTS.map((point) => <span key={point} className="auto-price-info-point">{point}</span>)}
            </span>
        </span>
    </span>
);

export default AutoPriceInfo;
